
export interface Environment<Keys> {
    prev?: Keys | null;
    next?: Keys | null;
    machine: StateMachine<Keys, any>;
    disposables: { dispose(): void }[];
}

export interface State<Keys, Context> {
    state: Keys | Keys[];
    enter?(ctx: Context, env: Environment<Keys>): void;
    exit?(ctx: Context, env: Environment<Keys>): void;
    disposables?: { dispose(): void }[];
}

export interface StateContextUpdate<Keys, Context> {
    ctx: Context;
    env:Environment<Keys>;
    disposables: { dispose(): void }[];
    old: Context;
}

export class StateMachine<Keys, Context> {

    public readonly onUpdateContext = e5.Signal.create<[StateContextUpdate<Keys, Context>]>();

    private _states: State<Keys, Context>[] = [];
    private _state: Keys = null;
    private _ctx: Context = null;
    private _ctxDisposables: { dispose(): void }[] = [];
    public readonly env:Environment<Keys> = {
        disposables: [],
        machine: this,
        next: null,
        prev: null
    };

    constructor() { }

    public set ctx(value: Context) {

        const old = this._ctx;

        for (let d of this._ctxDisposables) {
            d.dispose();
        }
        this._ctxDisposables = [];

        this._ctx = value;

        this.onUpdateContext.dispatch(
            {
                ctx: value,
                env: this.env,
                disposables: this._ctxDisposables,
                old: old
            });
    }

    public get ctx(): Context {
        return this._ctx;
    }

    public get stateForce(): Keys | null {
        return this._state;
    }

    public set stateForce(value: Keys) {
        if(value === this._state){
            this.state = null;
        }
        this.state = value;
    }

    public get state(): Keys | null {
        return this._state;
    }

    public set state(value: Keys) {

        if (this._state === value) {
            return;
        }

        this.env.prev = this._state;
        this.env.next = value;

        if (this._state) {

            for (let lis of this._states) {

                let keys: Keys[] = Array.isArray(lis.state) ? lis.state : [lis.state];
                let matchPrev = this.env.prev && keys.indexOf(this.env.prev) !== -1;
                let matchNext = this.env.next && keys.indexOf(this.env.next) !== -1;
                if (matchPrev && !matchNext) {

                    if (lis.disposables?.length > 0) {
                        for (let d of lis.disposables) {
                            d.dispose();
                        }
                        lis.disposables = lis.disposables.splice(0);
                    }

                    if (typeof lis.exit === "function") {
                        this.env.disposables = lis.disposables;
                        lis.exit(this._ctx, this.env);
                    }
                }
            }
        }

        this._state = value;
        e5.console.log(this.state);

        if (this._state) {

            for (let lis of this._states) {
                let keys: Keys[] = Array.isArray(lis.state) ? lis.state : [lis.state];
                let matchPrev = this.env.prev && keys.indexOf(this.env.prev) !== -1;
                let matchNext = this.env.next && keys.indexOf(this.env.next) !== -1;
                if (!matchPrev && matchNext) {
                    if (typeof lis.enter === "function") {
                        this.env.disposables = lis.disposables;
                        lis.enter(this._ctx, this.env);
                    }
                }
            }
        }
    }

    public clear(): void {
        this.state = null;
    }

    public on(state: State<Keys, Context>): State<Keys, Context> {
        state.disposables = [];
        this._states.push(state);
        return state;
    }
}